<template>
  <div>
    <div class="px-3">
      <h4 class="text-center font-weight-bold">마케팅 활용을 위한 개인정보 수집 및 이용 동의서</h4>
    </div>
    <table class="table table-borderless mt-3">
      <thead align="center">
        <tr style="border-top: 2px solid; border-bottom: 1px solid #cfcfcf; background-color: #f3f3f3">
          <th style="width: 40%; border-right: 1px solid #cfcfcf">마케팅 활용 항목</th>
          <th style="width: 40%; border-right: 1px solid #cfcfcf">수집 및 이용목적</th>
          <th style="width: 20%">보유기간</th>
        </tr>
      </thead>
      <tbody align="center">
        <tr style="border-bottom: 1px solid">
          <td style="border-right: 1px solid #cfcfcf; vertical-align: middle">
            <div>성명, 휴대폰, 이메일, 생년월일</div>
          </td>
          <td style="border-right: 1px solid #cfcfcf; vertical-align: middle">
            <ul class="text-left">
              <li>
                <div class="text-emphasis">
                  호텔 상품 및 프로모션, 이벤트에 대해 SMS, eDM, DM, TM을 통한 홍보, 리서치 등 마케팅 목적으로 활용
                </div>
              </li>
            </ul>
          </td>
          <td style="vertical-align: middle">
            <div class="text-emphasis">멤버십 가입기간 및 탈퇴 후 1년</div>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="px-2">
      마케팅 활용에 동의하지 않을 수 있으며, 미동의 시 멤버십 가입은 가능하나 서비스 이용에 제한이 있을 수 있습니다.
    </p>
  </div>
</template>

<script>
export default {
  name: 'MemberMarketingPrivacy',
};
</script>

<style scoped lang="scss">
.table {
  th,
  td {
    font-size: 0.9rem;
    vertical-align: middle;
  }
}
ul {
  margin: 0rem;
  padding-left: 1.5rem;
}
p {
  font-size: 0.9rem;
}
.text-emphasis {
  font-size: medium;
  font-weight: bold;
}
</style>
